import { FC } from "react";
import { CardActions, IconButton, Tooltip, Typography } from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";
import { formatCurrency } from "@/utils/dataFormat/formatCurrency";
import { useSearchParams } from "@/hooks/useSearchParams";
import { ISelectPaymentAccountParams } from "@/components/SelectPaymentAccount";
import { ROUTES } from "@/routing/constants";
import { IProduct } from "@/features/main/types";
import * as Styled from "./ProductCard.styles";

export const ProductCard: FC<IProduct> = ({
  id,
  title,
  tooltip,
  price,
  currency,
  buttonText,
  description,
}) => {
  const { parsedSearchParams } = useSearchParams<ISelectPaymentAccountParams>();

  return (
    <Styled.CardWrapper>
      <Styled.Card>
        <Styled.CardHeader
          title={
            <Styled.HeaderBox>
              <Typography
                variant="body1"
                color="primary"
                textAlign="left"
                fontWeight="500"
              >
                {title}
              </Typography>
              {tooltip && (
                <Tooltip title={tooltip}>
                  <IconButton>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Styled.HeaderBox>
          }
          titleTypographyProps={{ align: "center" }}
        />
        <Styled.CardContent>
          <Styled.ContentBox>
            <Typography variant="h4" color="text.primary" fontWeight="500">
              {formatCurrency(price, currency)}
            </Typography>
          </Styled.ContentBox>
          <Styled.List>
            {description?.map((line) => (
              <Typography component="li" variant="subtitle1" key={line}>
                {line}
              </Typography>
            ))}
          </Styled.List>
        </Styled.CardContent>
        <CardActions>
          <Styled.Button
            fullWidth
            variant="contained"
            href={ROUTES.payment.createURL(id, parsedSearchParams)}
          >
            {buttonText}
          </Styled.Button>
        </CardActions>
      </Styled.Card>
    </Styled.CardWrapper>
  );
};
